import { observable, action } from 'mobx';
import { IWebGivingPageViewModel, WebGivingPage } from './index';
import { WebGivingError } from '../components/error-message/error-message';
import { ValidationState } from '../validation/view-model-validator';

export abstract class WebGivingPageViewModelBase implements IWebGivingPageViewModel {
	abstract type: WebGivingPage;

	@observable
	isLoading: boolean = false;

	@observable
	isBlocked: boolean = false;

	@observable
	error: WebGivingError;

	@observable
	pageShouldBeVisible: boolean;

	@observable
	userActionState = { blocked: false };

	@observable
	disableValidation?: boolean;

	abstract validate(): ValidationState;

	@action.bound
	setPageShouldBeVisible() {
		this.pageShouldBeVisible = true;
	}

	@action.bound
	setDisableValidation(disableValidation?: boolean) {
		this.disableValidation = disableValidation;
	}

	@action.bound
	blockUserActions(): void {
		this.userActionState.blocked = true;
	}
}
